import React from 'react';
import style from './ChatroomListEntry.scss';
import classNames from 'classnames';
import utils from '../../../services/utils';
import { connect } from 'react-redux';
import {
  primaryColorOrDefault,
  textColorOrDefault,
  headerTextColorOrDefault,
} from '../../../reducers';
import { AVATARS } from '../../../constants/avatars';
import { Avatar as IAvatar } from '@wix/chat-web';
import Avatar from '../../Avatar/Avatar';

interface ChatroomListEntryProps {
  room: {
    id: string;
    name: string;
    text: string;
    count: number;
    online: boolean;
    timestamp: string;
    otherParticipantId?: string;
  };
  onClick(roomId: string): any;
  primaryColor: string;
  textColor: string;
  headerTextColor: string;
  avatar: IAvatar;
  shouldHaveDivider?: boolean;
}

class ChatroomListEntry extends React.Component<ChatroomListEntryProps> {
  static defaultProps: Partial<ChatroomListEntryProps> = {
    avatar: AVATARS.NONE.prop,
    shouldHaveDivider: false,
  };

  handleClick = () => {
    const { onClick, room } = this.props;
    onClick(room.id);
  };

  render() {
    const {
      room,
      avatar,
      textColor,
      primaryColor,
      headerTextColor,
      shouldHaveDivider,
    } = this.props;

    return (
      <div
        data-hook="chatroom-list-entry"
        className={style.root}
        onClick={this.handleClick}
      >
        <div className={style.avatar}>
          <Avatar avatar={avatar} />
        </div>
        <div
          className={style.roomTextDetails}
          style={{
            borderBottom: `${
              shouldHaveDivider
                ? `1px solid ${utils.getRgbA(textColor, 0.1)}`
                : ''
            }`,
          }}
        >
          <div className={style.flexRow}>
            <button
              data-hook="name"
              className={classNames(style.name, {
                [style.unread]: room.count,
              })}
            >
              {room.name}
            </button>

            {room.online ? (
              <div data-hook="online-badge">online</div>
            ) : (
              <span className={style.timestamp} data-hook="timestamp">
                {room.timestamp}
              </span>
            )}
          </div>
          <div className={style.flexRow}>
            {room.text && (
              <span
                data-hook="text"
                className={classNames({
                  [style.text]: true,
                  [style.unread]: room.count,
                })}
              >
                {room.text}
              </span>
            )}
            {room.count > 0 && (
              <span
                className={style.unreadMessagesPimple}
                style={{
                  backgroundColor: primaryColor,
                  color: headerTextColor,
                }}
                data-hook="unread-messages-pimple"
              >
                {room.count <= 99 ? room.count : 99}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    primaryColor: primaryColorOrDefault(state),
    textColor: textColorOrDefault(state),
    headerTextColor: headerTextColorOrDefault(state),
  };
}

export default connect(mapStateToProps)(
  ChatroomListEntry as React.ComponentType<ChatroomListEntryProps>,
);
